/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ChaXunCanShu,
  MenuDO,
  ResponseApi,
  ResponseApiListMenuButtonVO,
  ResponseApiListMenuDTO,
  ResponseApiListMenuVO,
  ResponseApiPageMenuDTO,
  ResponseApiSetLong,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class XiTongCaiDanGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags XiTongCaiDanGuanLi
   * @name QueryUsingGet2
   * @summary 查询菜单
   * @request GET:/dsp-admin/api/sys/menus
   * @secure
   */
  queryUsingGet2 = (
    query?: {
      blurry?: string;
      gmtCreate?: string[];
      "permissionDataRuleList[0].column"?: string;
      "permissionDataRuleList[0].isActivated"?: boolean;
      "permissionDataRuleList[0].menuPermission"?: string;
      "permissionDataRuleList[0].name"?: string;
      "permissionDataRuleList[0].value"?: object;
      /** @format int64 */
      pid?: number;
      pidIsNull?: boolean;
      /** @format int32 */
      type?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiPageMenuDTO, void>({
      path: `/dsp-admin/api/sys/menus`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongCaiDanGuanLi
   * @name CreateUsingPost1
   * @summary 新增菜单
   * @request POST:/dsp-admin/api/sys/menus
   * @secure
   */
  createUsingPost1 = (resources: MenuDO, params: RequestParams = {}) =>
    this.request<ResponseApi, void>({
      path: `/dsp-admin/api/sys/menus`,
      method: "POST",
      body: resources,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongCaiDanGuanLi
   * @name UpdateUsingPut1
   * @summary 修改菜单
   * @request PUT:/dsp-admin/api/sys/menus
   * @secure
   */
  updateUsingPut1 = (resources: MenuDO, params: RequestParams = {}) =>
    this.request<ResponseApi, void>({
      path: `/dsp-admin/api/sys/menus`,
      method: "PUT",
      body: resources,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongCaiDanGuanLi
   * @name DeleteUsingDelete1
   * @summary 删除菜单
   * @request DELETE:/dsp-admin/api/sys/menus
   * @secure
   */
  deleteUsingDelete1 = (ids: number[], params: RequestParams = {}) =>
    this.request<ResponseApi, void>({
      path: `/dsp-admin/api/sys/menus`,
      method: "DELETE",
      body: ids,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongCaiDanGuanLi
   * @name BuildMenusUsingGet
   * @summary 获取前端所需菜单
   * @request GET:/dsp-admin/api/sys/menus/build
   * @secure
   */
  buildMenusUsingGet = (params: RequestParams = {}) =>
    this.request<ResponseApiListMenuVO, void>({
      path: `/dsp-admin/api/sys/menus/build`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongCaiDanGuanLi
   * @name ChildUsingGet
   * @summary 根据菜单ID返回所有子节点ID，包含自身ID
   * @request GET:/dsp-admin/api/sys/menus/child
   * @secure
   */
  childUsingGet = (
    query: {
      /**
       * id
       * @format int64
       */
      id: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiSetLong, void>({
      path: `/dsp-admin/api/sys/menus/child`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongCaiDanGuanLi
   * @name DownloadUsingGet
   * @summary 导出数据
   * @request GET:/dsp-admin/api/sys/menus/download
   * @secure
   */
  downloadUsingGet = (
    query?: {
      blurry?: string;
      gmtCreate?: string[];
      "permissionDataRuleList[0].column"?: string;
      "permissionDataRuleList[0].isActivated"?: boolean;
      "permissionDataRuleList[0].menuPermission"?: string;
      "permissionDataRuleList[0].name"?: string;
      "permissionDataRuleList[0].value"?: object;
      /** @format int64 */
      pid?: number;
      pidIsNull?: boolean;
      /** @format int32 */
      type?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/dsp-admin/api/sys/menus/download`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongCaiDanGuanLi
   * @name SelectMenuIconUsingGet
   * @summary 查询菜单图标
   * @request GET:/dsp-admin/api/sys/menus/icon
   * @secure
   */
  selectMenuIconUsingGet = (
    queryDTO: ChaXunCanShu,
    query?: {
      countId?: string;
      /** @format int64 */
      current?: number;
      /** @format int64 */
      maxLimit?: number;
      optimizeCountSql?: boolean;
      "orders[0].asc"?: boolean;
      "orders[0].column"?: string;
      records?: object[];
      searchCount?: boolean;
      /** @format int64 */
      size?: number;
      /** @format int64 */
      total?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<ResponseApi, void>({
      path: `/dsp-admin/api/sys/menus/icon`,
      method: "GET",
      query: query,
      body: queryDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongCaiDanGuanLi
   * @name QueryUsingGet3
   * @summary 返回全部的菜单
   * @request GET:/dsp-admin/api/sys/menus/lazy
   * @secure
   */
  queryUsingGet3 = (
    query: {
      /**
       * pid
       * @format int64
       */
      pid: number;
      /**
       * roleId
       * @format int64
       */
      roleId: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiListMenuDTO, void>({
      path: `/dsp-admin/api/sys/menus/lazy`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongCaiDanGuanLi
   * @name MenuAndBtnUsingGet
   * @summary 获取所有菜单和功能按钮
   * @request GET:/dsp-admin/api/sys/menus/menuAndButton
   * @secure
   */
  menuAndBtnUsingGet = (params: RequestParams = {}) =>
    this.request<ResponseApiListMenuButtonVO, void>({
      path: `/dsp-admin/api/sys/menus/menuAndButton`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongCaiDanGuanLi
   * @name QueryUsingGet1
   * @summary 查询菜单分页
   * @request GET:/dsp-admin/api/sys/menus/page
   * @secure
   */
  queryUsingGet1 = (
    query?: {
      blurry?: string;
      countId?: string;
      /** @format int64 */
      current?: number;
      gmtCreate?: string[];
      /** @format int64 */
      maxLimit?: number;
      optimizeCountSql?: boolean;
      "orders[0].asc"?: boolean;
      "orders[0].column"?: string;
      "permissionDataRuleList[0].column"?: string;
      "permissionDataRuleList[0].isActivated"?: boolean;
      "permissionDataRuleList[0].menuPermission"?: string;
      "permissionDataRuleList[0].name"?: string;
      "permissionDataRuleList[0].value"?: object;
      /** @format int64 */
      pid?: number;
      pidIsNull?: boolean;
      records?: object[];
      searchCount?: boolean;
      /** @format int64 */
      size?: number;
      /** @format int64 */
      total?: number;
      /** @format int32 */
      type?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiPageMenuDTO, void>({
      path: `/dsp-admin/api/sys/menus/page`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongCaiDanGuanLi
   * @name GetSuperiorUsingPost1
   * @summary 查询菜单:根据ID获取同级与上级数据
   * @request POST:/dsp-admin/api/sys/menus/superior
   * @secure
   */
  getSuperiorUsingPost1 = (ids: number[], params: RequestParams = {}) =>
    this.request<ResponseApiListMenuDTO, void>({
      path: `/dsp-admin/api/sys/menus/superior`,
      method: "POST",
      body: ids,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new XiTongCaiDanGuanLi();
